export default 'https://tme.understood.org/assets/global_intro.en.bb9c8ce9.vtt'